import React, { useState } from 'react'
import Header from '../src/layouts/header/Header.js';
import { Outlet } from 'react-router-dom';
import Sidebar from './layouts/sidebar/Sidebar.js';
import ProtectedRoute from './utils/ProtectedRoute.js';
import BackButton from './components/BackButton/backbutton.js';


const Layout = ({dynamicMenus}) => {
    const [isCollapsed, setIsCollapsed] = useState(false)
  
  return (
    <ProtectedRoute>
      <Header />
        <div className='content' style={{marginLeft: !isCollapsed ? '250px' : '80px'}}>
        {/* <BackButton isCollapsed={isCollapsed} /> */}

        <Outlet/>
        </div>
        {dynamicMenus ? (
        <Sidebar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          dynamicMenus={dynamicMenus}
        />
      ) : (
        <Sidebar
         
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      )}     </ProtectedRoute>
  )
}

export default Layout;